import { useInfiniteQuery } from "react-query";
import { queryGet } from "../../../utils/queryClient";

const DEFAULT_PAGE_SIZE = 10;

export default function useBuddyUserProfilesQuery() {
  const {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(
    ["BuddyUserProfiles"],
    ({ pageParam = 1 }) => {
      const queryParams = new URLSearchParams({
        page: pageParam,
        per_page: DEFAULT_PAGE_SIZE
      });

      return queryGet(`/api/v1/buddy_preferences?${queryParams.toString()}`);
    },
    {
      getNextPageParam: (lastPage, _) => lastPage?.meta?.pagination?.nextPage,
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage,
  };
}
